import { Sized } from '@optimus-web/common';
import { getDasharray, getSizeProperties } from './helpers';
import { CircleLoaderIndicator, CircleLoaderTrack, CircleLoaderWrapper } from './style';
import { LoaderMode } from './types';

export interface BaseComponentProps extends Sized {
    mode: LoaderMode;
    value?: number;
}

const BaseComponent: React.FC<BaseComponentProps> = ({ size = 'medium', mode, value = 0, ...other }) => {
    const { dimension, radius, strokeWidth } = getSizeProperties(size);
    const dasharray = getDasharray(radius, mode === LoaderMode.Determinate ? value : 0.25);

    return (
        <CircleLoaderWrapper
            width={dimension}
            height={dimension}
            viewBox={`0 0 ${dimension} ${dimension}`}
            fill="none"
            {...other}
        >
            <CircleLoaderTrack cx={dimension / 2} cy={dimension / 2} r={radius} strokeWidth={strokeWidth} />
            <CircleLoaderIndicator
                mode={mode}
                cx={dimension / 2}
                cy={dimension / 2}
                r={radius}
                strokeDasharray={dasharray}
                strokeWidth={strokeWidth}
            />
        </CircleLoaderWrapper>
    );
};

export default BaseComponent;
